import { mdiAccountCircle, mdiChevronDown, mdiClose, mdiHome, mdiMenu } from '@mdi/js';
import Icon from '@mdi/react';
import get from 'lodash/get';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { scroller } from 'react-scroll';
import { PATH, SUBSCRIPTION_NAVBAR } from '../../../../constants';
import { signInClick, subscribeClick } from '../../../../helpers/datalayer-utils';
import {
  getSSOLoginUrl,
  getSSOLogoutUrl,
  getSSORedirectUrl,
} from '../../../../helpers/subscription-helper';
import { clearSSOUserDetails, getUserInitials, verifySSODetails } from '../../../../helpers/utils';
import { BQLink } from '../../../atoms/bqlink';
import ShineButton from '../../../atoms/shine-button';
import SvgIcon from '../../../atoms/svg-icon';
import DropdownMenu from '../../../molecules/member-menu/dropdown-menu';
import './subscription-navbar.m.css';

const SubscriptionNavbar = ({ churnUserPage, isMenu, hideShowMobileMenu, isOfferPage }) => {
  const dispatch = useDispatch();
  const client_id = useSelector((state) =>
    get(state, ['qt', 'config', 'integrations', 'sso', 'client_id'], null),
  );
  const client_secret = useSelector((state) =>
    get(state, ['qt', 'config', 'integrations', 'sso', 'client_secret'], null),
  );
  const userData = useSelector((state) => get(state, ['userData']));
  const isSubscriber = useSelector((state) => get(state, ['userData', 'isSubscriber'], null));
  const isLoggedIn = useSelector((state) => get(state, ['userData', 'isLoggedIn'], null));
  const userProfile = useSelector((state) => get(state, ['userData', 'userProfile'], null));
  const SSO_LOGIN_URL = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'subscription', 'login_url'], null),
  );
  const SSO_LOGOUT_URL = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'subscription', 'logout_url'], null),
  );
  // const firstName = get(userProfile, 'fullName', '').split(' ')[0];
  const environment = useSelector((state) =>
    get(state, ['qt', 'config', 'publisher', 'environment'], null),
  );
  const [isScrolled, setIsScrolled] = useState(false);
  const [isModal, setModal] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState('');
  const [loginUrl, setLoginUrl] = useState('');
  const [showBtnLoader, setShowBtnLoader] = useState(true);
  const integrations = useSelector((state) => get(state, ['qt', 'config', 'integrations'], {}));
  const [isMobile, setIsMobile] = useState(false);
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 767);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const url = new URL(window?.location?.href);
    getSSORedirectUrl(url).then((pageUrl) => {
      setRedirectUrl(pageUrl);
    });

    const authCode = url?.searchParams?.get('authorizationCode');
    const accessToken = document?.cookie
      ?.split(';')
      ?.find((c) => c.indexOf('sso_access_token') > -1);
    const accesstypeJwtSecret = integrations?.accesstype?.jwtSecret;
    const metypeJwtSecret = integrations?.metype?.jwtSecret;
    const LOGIN_SUCCESS_FLAG = 'loginSignupSuccessTriggered';
    const saveAuthCookies = async () =>
      await verifySSODetails({
        authCode,
        accessToken,
        client_id,
        client_secret,
        environment,
        dispatch,
        accesstypeJwtSecret,
        metypeJwtSecret,
        pageType,
      });

    saveAuthCookies();

    if (window?.location?.search === '?logoutAction=success') {
      window.history.replaceState(null, '', window.location.pathname);
      window.localStorage.setItem(LOGIN_SUCCESS_FLAG, 'false');
    }
    if (window?.location?.search === '?logoutAction=failure') {
    }

    const handleScroll = () => {
      const scrolled = window.scrollY > 0;
      setIsScrolled(scrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    getSSOLoginUrl(
      integrations?.sso?.client_id,
      integrations?.sso?.client_secret,
      redirectUrl,
      SSO_LOGIN_URL,
    ).then((pageUrl) => {
      setLoginUrl(pageUrl);
    });
  }, [redirectUrl]);

  useEffect(() => {
    if (isLoggedIn === null) {
      setShowBtnLoader(true);
    } else {
      setShowBtnLoader(false);
    }
  }, [isLoggedIn]);

  const handleClick = (id) => {
    if (id === 'subscription-home') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      scroller.scrollTo(id, {
        duration: 800,
        delay: 0,
        smooth: 'easeInOutQuart',
        offset: id === 'footer' ? 0 : -120, // Adjust offset if needed
      });
    }
    if (window?.innerWidth <= 767) {
      hideShowMobileMenu(false);
    }
  };

  const handleLogout = async () => {
    window.location = await getSSOLogoutUrl(
      integrations?.sso?.client_id,
      integrations?.sso?.client_secret,
      redirectUrl,
      SSO_LOGOUT_URL,
    );
    await setShowBtnLoader(true);
    await setModal(!isModal);
    await clearSSOUserDetails(dispatch);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isModal && !event.target.closest('.modal-content')) {
        setModal(false);
      }
    };

    document.getElementsByTagName('body')[0].style.overflowY =
      isModal || isMenu ? 'hidden' : 'scroll';
    window.addEventListener('click', handleClickOutside);

    return () => {
      document.getElementsByTagName('body')[0].style.overflowY = 'scroll';
      window.removeEventListener('click', handleClickOutside);
    };
  }, [isModal, isMenu]);

  return (
    <>
      <nav
        styleName={`menu-container ${isScrolled ? 'scroll-container' : ''} ${
          !isScrolled && isMenu ? 'bg-wrap' : ''
        }`}
        className="container"
      >
        <div styleName="icons-wrap">
          {!churnUserPage && (
            <div
              href="/?src=header"
              styleName="home-icon"
              className="mobile-only"
              onClick={() => hideShowMobileMenu(!isMenu)}
            >
              {isMenu ? (
                <Icon path={mdiClose} size="20px" color="#5A472C" />
              ) : (
                <Icon path={mdiMenu} size="20px" color="#5A472C" />
              )}
            </div>
          )}
          <BQLink href="/?src=header" styleName="home-icon">
            <Icon path={mdiHome} size="20px" color="#5A472C" />
          </BQLink>
        </div>
        <div onClick={() => handleClick('subscription-home')} styleName="profit-logo">
          <SvgIcon
            type="NDTV_profit_logo.png"
            width="157px"
            height="28px"
            source="image"
            isSvg={false}
          />
        </div>
        <ul styleName="item-list">
          {!churnUserPage &&
            SUBSCRIPTION_NAVBAR &&
            SUBSCRIPTION_NAVBAR.map((list, index) => (
              <li
                styleName="item"
                onClick={() => handleClick(list.link)}
                className="desktop-only"
                key={index}
              >
                {list.title}
              </li>
            ))}
          <li styleName="item opacity">
            {showBtnLoader ? (
              <div styleName="btn-loading-grey" />
            ) : isLoggedIn ? (
              <div styleName="signin-btn item user" onClick={() => setModal(!isModal)}>
                <Icon path={mdiAccountCircle} size="20px" />
                {getUserInitials(userProfile) && !isMobile && (
                  <span className="desktop-only">
                    {userProfile?.fullName?.split(' ')[0] || getUserInitials(userProfile) || ''}
                  </span>
                )}
                {getUserInitials(userProfile) && isMobile && (
                  <span className="mobile-only">{getUserInitials(userProfile) || ''}</span>
                )}
                <Icon path={mdiChevronDown} size="20px" />
              </div>
            ) : (
              <div
                onClick={() =>
                  signInClick(userData, 'section-page', 'Sign In', 'subscription-page-header')
                }
                styleName="signin-btn item"
              >
                <BQLink href={loginUrl}>Sign In</BQLink>
              </div>
            )}
            {!isOfferPage && (
              <>
                {showBtnLoader || isSubscriber === null ? (
                  <div styleName="btn-loading-grey" className="desktop-only" />
                ) : (
                  <div
                    onClick={() =>
                      subscribeClick(userData, 'section-page', 'subscription-page-header')
                    }
                  >
                    {!isSubscriber && (
                      <BQLink
                        href={PATH.SUBSCRIPTION_PAGE}
                        styleName={`item sub-btn ${!isScrolled ? 'scroll-none' : ''}`}
                        className="desktop-only"
                      >
                        <ShineButton
                          className="shine-button"
                          size="medium"
                          label="Subscribe"
                          rounded="full"
                        ></ShineButton>
                      </BQLink>
                    )}
                  </div>
                )}
              </>
            )}
          </li>
        </ul>
        {isModal && (
          <>
            <div styleName={`overlay-div ${isModal ? 'overlay-open' : ''}`}> </div>
            <DropdownMenu subscriptionPage={true} isScrolled={isScrolled} logout={handleLogout} />
          </>
        )}
      </nav>
      {isMenu && (
        <div className="mobile-only" styleName="menu-list">
          <div styleName="blur">
            {SUBSCRIPTION_NAVBAR &&
              SUBSCRIPTION_NAVBAR.map((list, index) => (
                <div styleName="mobile-list" onClick={() => handleClick(list.link)} key={index}>
                  {list.title}
                </div>
              ))}
          </div>
        </div>
      )}
    </>
  );
};

export default SubscriptionNavbar;
